module.exports = __webpack_public_path__ + "img/healthProMobile2.cb776d09.png";